import { useEffect, useState } from 'react'
import { useAuth } from '../../modules/auth/core/Auth'
import { IsGranted } from '../../modules/auth/PrivateRoute'
import { ROLE } from '../../modules/auth/core/_models'
import { getMyLedgerBalances } from './core/api'
import { IMyLedgerBalances } from './core/types'
import { LedgerBalanceCluster } from './LedgerBalanceCluster'
import { LedgerBalancePopover } from './LedgerBalancePopover'

type Status = 'loading' | 'ok' | 'hidden'

export default function LedgerHeaderBalance() {
  const { currentUser } = useAuth()
  const granted =
    IsGranted([ROLE.ROLE_SENIOR_OPERATOR, ROLE.ROLE_SENIOR_CASHIER], currentUser) &&
    !IsGranted([ROLE.ROLE_MANAGER], currentUser)

  const [status, setStatus] = useState<Status>('loading')
  const [data, setData] = useState<IMyLedgerBalances | null>(null)

  useEffect(() => {
    if (!granted) {
      return
    }
    let alive = true
    setStatus('loading')
    getMyLedgerBalances()
      .then((res) => {
        if (!alive) {
          return
        }
        const body = res.data
        // No summary means nothing renderable in the navbar (e.g. every wallet
        // is not_found) — hide the widget rather than show an empty pill.
        if (body && body.success && body.data.items.length > 0 && body.data.summary.length > 0) {
          setData(body.data)
          setStatus('ok')
        } else {
          setStatus('hidden')
        }
      })
      .catch(() => {
        if (alive) {
          setStatus('hidden')
        }
      })
    return () => {
      alive = false
    }
  }, [granted, currentUser])

  if (!granted || status !== 'ok' || !data) {
    return null
  }

  const hasBlocked = data.items.some((i) => i.isBlocked)
  const cluster = (
    <LedgerBalanceCluster summary={data.summary} hasBlocked={hasBlocked} entityCount={data.items.length} />
  )

  // The popover carries whatever the single-row header cannot: the per-merchant
  // split, and every currency when they cannot be summed into one figure.
  if (data.items.length > 1 || data.summary.length > 1) {
    return <LedgerBalancePopover data={data}>{cluster}</LedgerBalancePopover>
  }

  return cluster
}
